import React from 'react';
import Button from '@material-ui/core/Button';
import { resendDeclarationLink } from '../../services/customer.service';

const resendSelfDeclarationLink = ({ data }) => {
    const { self_declaration_id, program_id } = data;

    const onClick = async () => {
        if (window.confirm(`Are you sure you want to resend self declaration link?`)) {
            await resendDeclarationLink({
                program_id: program_id,
                self_declaration_id: self_declaration_id,
            })
            .then((res) => {
                alert(res.message);
                window.location.reload();
            })
            .catch((err) => alert(err.message));
        }
    };

    return (
        <Button variant="contained" onClick={onClick} style={{ marginRight: 8 }}>Resend Self Declaration Link</Button>
    )
}

export default resendSelfDeclarationLink;
